import React, { useMemo, useState, useEffect } from "react";

/** needs name and code filled inside row */
function NameCodeRowUI({ row }) {
  if (!row) return <span></span>;

  return (
    <a
      href={row.url || "#"}
      className="
        no-underline inline-flex max-w-full
        rounded-2xl transition
        focus:outline-none focus:ring-2 focus:ring-orange-300 focus:ring-offset-2
      "
    >
      <span
        className="
          inline-flex min-h-[34px] max-w-[180px] items-center justify-center
          rounded-2xl border border-slate-200 bg-white
          px-4 py-1.5 text-sm font-medium leading-5 text-slate-700
          shadow-sm transition
          hover:border-orange-200 hover:bg-orange-50 hover:text-orange-700
          active:scale-[0.98]
          sm:max-w-[220px]
        "
      >
        <span
          className="
            text-center whitespace-normal break-words
          "
        >
          {row.name}
        </span>
      </span>
    </a>
  );
}

/** needs name and code filled inside row */
function NameCodeRowUIOld({ row }) {
    if(!row) return (<span></span>);
  return (
     <a
        href={row.url || '#'}
        className="rounded-full  px-1 py-1  transition
        text-center items-center justify-center"
      >
    <span
      className="rounded-full bg-slate-200 
      hover:bg-orange-600 hover:text-white
       px-4 py-1 text-sm text-slate-700
       text-center items-center justify-center"
    >
     
        {row.name}
     
    </span>
     </a>
  );
}

/**
 * Tag UI Component
 * Props:
 * - text: string (required)
 * - bgColor: tailwind bg color (default: bg-orange-700)
 * - textColor: tailwind text color (default: text-white)
 */
function TagUITablet({
  text,
  bgColor = "bg-orange-500",
  textColor = "text-white"
}) {
  if (!text) return <span></span>;

  return (
    <span
      className={`rounded-full ${bgColor} ${textColor}
        px-2 py-1 text-sm 
        flex items-center justify-center`}
    >
      {text}
    </span>
  );
}

/**
 * show medium/hard/easy tag tablets based on question difficult
 */
function QuestionDifficultyTagUI({difficulty=0}){
  return (
  <TagUITablet 
    text = {difficulty==1?'Medium': difficulty==2?'Hard':'Easy'}
    bgColor={difficulty === 1 ? 'bg-orange-500' :
              difficulty === 2 ? 'bg-red-500' :'bg-green-500'
            }
    />
  )
}

/** Button used for the "+n more" trigger */
function TagsNMoreButton({ n, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="px-3 py-1 text-sm font-medium rounded-full
       bg-slate-600 text-white hover:bg-slate-700 focus:outline-none
        focus:ring-2 focus:ring-offset-2 focus:ring-slate-500"
      aria-label={`Show ${n} more tags`}
    >
      +{n} more
    </button>
  );
}

/** Simple accessible modal */
function TagsListModal({ title = "All Companies", open, onClose, children }) {
  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") onClose();
    }
    if (open) document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="
        fixed inset-0 z-50 flex items-center justify-center
        bg-slate-950/40 px-3 py-4
      "
    >
      <div
        className="absolute inset-0"
        onClick={onClose}
        aria-hidden="true"
      />

      <div
        role="dialog"
        aria-modal="true"
        className="
          relative flex max-h-[calc(100vh-2rem)] w-full max-w-lg
          flex-col overflow-hidden rounded-2xl bg-white shadow-2xl
        "
      >
        <div
          className="
            flex shrink-0 items-center justify-between gap-3
            border-b border-slate-100 px-4 py-3 sm:px-5
          "
        >
          <h3 className="text-lg font-bold text-slate-900">
            {title}
          </h3>

          <button
            type="button"
            onClick={onClose}
            className="
              flex h-9 w-9 shrink-0 items-center justify-center rounded-full
              text-xl leading-none text-slate-500 transition
              hover:bg-slate-100 hover:text-slate-900
              focus:outline-none focus:ring-2 focus:ring-slate-300
            "
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-4 py-5 sm:px-5">
          <div className="flex flex-wrap justify-center gap-3">
            {children}
          </div>
        </div>

        <div className="shrink-0 border-t border-slate-100 bg-white px-4 py-3 sm:px-5">
          <button
            type="button"
            onClick={onClose}
            className="
              w-full rounded-xl bg-slate-900 py-2.5
              text-sm font-semibold text-white transition
              hover:bg-slate-700
              focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2
            "
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

/** Simple accessible modal */
function TagsListModalOld({ title = "All Companies", open, onClose, children }) {
  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") onClose();
    }
    if (open) document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50">
      <div
        className="absolute inset-0 bg-black/40"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="relative mx-auto mt-24 w-11/12 max-w-3xl rounded-2xl bg-white shadow-xl">
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <h3 className="text-lg font-semibold text-slate-800">{title}</h3>
          <button
            type="button"
            onClick={onClose}
            className="rounded-md px-2 py-1 text-slate-600 
            hover:text-slate-900 hover:bg-slate-100 focus:outline-none
             focus:ring-2 focus:ring-offset-2 focus:ring-slate-500"
            aria-label="Close"
          >
            ✕
          </button>
        </div>
        <div className="p-4">{children}</div>
        <div className="px-4 pb-4">
          <button
            type="button"
            onClick={onClose}
            className="w-full rounded-lg bg-slate-800 text-white py-2
             hover:bg-slate-600 focus:outline-none focus:ring-2 
             focus:ring-offset-2 focus:ring-slate-500"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

/**
 * title: e.g. 14. Design Unix 'find' command for file search
 * tags: Array<{ name: string, code: string, url: String }>
 * - url is the url to visit when tag is clicked
 * Rules:
 * - If 1–2 tags: show on one row
 * - If >=3 tags: show first two on row 1, the 3rd on row 2
 *   - Only show "+n more" if there are >3 total (n = total - 3)
 * Modal lists all tags sorted by name, 4 per row.
 */
function TagsListUI({title="", tags = [] }) {
  const [open, setOpen] = useState(false);

  const total = tags.length;
  const firstRow = total <= 2 ? tags : tags.slice(0, 2);
  const secondRowThird = total >= 3 ? [tags[2]] : [];
  const hiddenCount = total > 3 ? total - 3 : 0;

  const sortedAll = useMemo(
    () => [...tags].sort((a, b) => a.name.localeCompare(b.name)),
    [tags]
  );

    useEffect(() => {
     // console.log("inside tags list ui. tags length "+tags.length);
      // console.log(JSON.stringify(tags))
      
      
  }, []);

  if(!tags) return(<span></span>);
  
  return (
    <>
      {/* Visible preview area */}
      <div className="flex flex-col gap-2">
        {/* Row 1 */}
        <div className="flex flex-row flex-wrap items-center gap-2">
          {firstRow.map((c) => (
            <NameCodeRowUI key={c.code} row={c} />
          ))}
        </div>

        {/* Row 2 (only if >=3) */}
        {total >= 3 && (
          <div className="flex flex-row flex-wrap  gap-2
          ">
            {secondRowThird.map((c) => (
              <NameCodeRowUI key={c.code} row={c} />
            ))}
            {hiddenCount > 0 && (
              <TagsNMoreButton n={hiddenCount} onClick={() => setOpen(true)} />
            )}
          </div>
        )}
      </div>

      {/* Modal for all tags */}
      <TagsListModal open={open} onClose={() => setOpen(false)} title={title}>
        <div className="grid grid-cols-4 gap-6">
          {sortedAll.map((c) => (
            <NameCodeRowUI key={c.name} row={c} />
          ))}
        </div>
      </TagsListModal>
    </>
  );
}

/**
 * calculates number of visible companies by number of characters
 */
function getVisibleCompanyCount(companies = [], maxVisibleChars = 30) {
  let totalChars = 0;
  let visibleCount = 0;

  for (const company of companies) {
    const companyNameLength = company?.name?.length || 0;
    const nextTotal = totalChars + companyNameLength;

    if (nextTotal > maxVisibleChars) {
      break;
    }

    totalChars = nextTotal;
    visibleCount++;
  }

  return Math.max(1, visibleCount);
}

/**
 * show list of companies on question page in a single row
 * 
 * - these are the companies where this question was asked
 */
function CompanyTagListToggle({ 
  companies = [] , visibleCompaniesCharactersCount=30 }) {
  const [expanded, setExpanded] = useState(false);

  if (!companies || companies.length === 0) {
    return null;
  }

  const visibleCount = getVisibleCompanyCount(
      companies, visibleCompaniesCharactersCount);
  const hiddenCount = companies.length - visibleCount;

//  const visibleCompanies = expanded ? companies : companies.slice(0, visibleCount);

  return (
    <div className="w-full">
      <div className="flex items-start gap-3">
        <span className="font-semibold text-gray-900 whitespace-nowrap">
          Asked in
        </span>

        <div className="flex-1 min-w-0">
          {/* 
            All companies are always rendered in DOM for SEO.
            Collapsed state only limits visible height, no text truncation.
          */}
          <div
            className={`
              flex flex-wrap gap-2 overflow-hidden transition-all 
              duration-300 ease-in-out
              ${expanded ? "max-h-[500px]" : "max-h-9"}
            `}
          >
            {/* className="inline-flex items-center rounded-full border
                 border-gray-200 bg-white px-3 py-1 text-sm font-medium
                  text-gray-700 shadow-sm" */}
            {companies.map((company, index) => (

               <a
                key={company.code}
               
        href={`/lld/${company.code}`}
        target="_blank"
        rel="noopener noreferrer"
        className="rounded-full  px-1 py-1  transition
        text-center items-center justify-center"
      >
              <span
                className={`
      inline-flex items-center rounded-full border  px-2
      hover:font-normal font-medium bg-gray-50
      text-gray-700 shadow-sm hover:bg-orange-600 hover:text-white 
      
      ${!expanded && index >= visibleCount ? "sr-only" : ""}
    `}
                
              >
                {company.name}
              </span>
              </a>
            ))}
          </div>
        </div>

        {hiddenCount > 0  && 
          <button
            type="button"
            onClick={() => setExpanded((prev) => !prev)}
            className="shrink-0 rounded-full border border-gray-300
             bg-white px-3 mr-6 py-1 text-sm font-medium text-blue-700 
             shadow-sm hover:bg-blue-50"
          >
            {expanded ? "See less" : `+${hiddenCount} more`} 
          </button>
        }
      </div>
    </div>
  );
}

function CompanyMetadataListSingleRowUI({
  title = "Companies",
  companies = [],
  count = 4,
  query = ""
}) {
  const [open, setOpen] = useState(false);

  const filteredCompanies = useMemo(() => {
    const q = (query || "").trim().toLowerCase();
    const list = companies || [];

    if (!q) {
      return list;
    }

    return list.filter((company) => {
      const combinedSearchText = [
        company.companyName,
        company.companyCode,
        company.searchText
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      return combinedSearchText.includes(q);
    });
  }, [companies, query]);

  const visibleCompanies = filteredCompanies.slice(0, count);
  const hiddenCount = Math.max(0, filteredCompanies.length - count);

  const sortedAll = useMemo(
    () =>
      [...filteredCompanies].sort((a, b) =>
        (a.companyName || a.companyCode || "").localeCompare(
          b.companyName || b.companyCode || ""
        )
      ),
    [filteredCompanies]
  );

  if (!companies || companies.length === 0) {
    return <span></span>;
  }

  return (
    <>
      <div className="flex flex-row flex-wrap items-center gap-2">
        {visibleCompanies.map((company) => {
          const row = {
            name: company.companyName || company.companyCode,
            code: company.companyCode,
            url: `/lld/${company.companyCode}`
          };

          return <NameCodeRowUI key={company.companyCode} row={row} />;
        })}

        {hiddenCount > 0 && (
          <TagsNMoreButton n={hiddenCount} onClick={() => setOpen(true)} />
        )}
      </div>

      <TagsListModal open={open} onClose={() => setOpen(false)} title={title}>
        <div className="grid grid-cols-4 gap-6">
          {sortedAll.map((company) => {
            const row = {
              name: company.companyName || company.companyCode,
              code: company.companyCode,
              url: `/lld/${company.companyCode}`
            };

            return <NameCodeRowUI key={company.companyCode} row={row} />;
          })}
        </div>
      </TagsListModal>
    </>
  );
}

export {TagsListUI, CompanyTagListToggle, TagUITablet,
  CompanyMetadataListSingleRowUI,  QuestionDifficultyTagUI}
